import React from 'react';
import './footer.scss';
import { Button } from 'react-bootstrap';
import { FaChevronUp, FaFacebookF, FaInstagram, FaHeart } from 'react-icons/fa';

class Footer extends React.Component {

  render() {
    return (
      <div className="component footer">
        <div className="goToTopC">
          <Button className="goToTop" variant="none" onClick={ () => window.scroll({top: 0, left: 0, behavior: 'smooth' }) }>
            <FaChevronUp />
          </Button>
        </div>
        <div className="copyrightC bodyFont">
          <span>GSHR.ge <FaHeart color="red" /> 2019</span>
          <span className="separator">|</span>
          <a href="https://www.facebook.com/GSHR.ge" target="_blank" rel="noopener noreferrer"><FaFacebookF color="#4267b2" /></a>
          <a href="https://www.instagram.com/gshr.ge" target="_blank" rel="noopener noreferrer"><FaInstagram color="#c72d8e" /></a>
        </div>
      </div>
    );
  }

}

export default Footer;